// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submit_toolbar{margin:3%}.upload_container{margin:1%;border:1px solid #9ecae1;height:100%;border-radius:10px;padding:1%}.text_tsv{display:block;float:left;padding:.5%}.error_msg{float:left;color:red;font-weight:bold;width:100%;padding:1%}\n", ""]);
// Exports
module.exports = exports;
